import { string } from 'yup'

export default string()
  .required()
  .matches(
    // eslint-disable-next-line no-empty-character-class
    /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/,
    '00/00/0000'
  )
